import axios from '@/libs/api.request'

export const getHrbussinessconfiglist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/hrbussinessconfig/hrbussinessconfig/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationHrbussinessconfig = (data, meth) => {
  return axios.request({
    url: '/v1/hrbussinessconfig/hrbussinessconfig/',
    method: meth,
    data
  })
}
